import React, { useEffect } from 'react';
import Image from '../components/Image';
import Button from '../components/Button';
import CallForAction from '../components/CallForAction';
import "./backgroundVisuals.css";

interface FeatureProps {
	icon: string;
	title: string;
	description: string;
	className?: string;
}

const Feature: React.FC<FeatureProps> = ({ icon, title, description, className }) => (
	<div className={`flex flex-col px-8 py-12 rounded-3xl border border-solid border-gray-200 border-opacity-30 max-md:px-5 ${className}`}>
		<Image src={icon} alt={title} className="aspect-square w-[62px]" />
		<div className="mt-9 text-3xl font-bold leading-8 text-white">{title}</div>
		<div className="mt-6 text-xl leading-7 text-zinc-400">{description}</div>
	</div>
);

const features = [
	{
		icon: "./assets/dao.svg",
		title: "DAOs",
		description: "Tool for organizations",
	},
	{
		icon: "./assets/proofOfDisplay.svg",
		title: "Proof-of-Display",
		description: "Validate provider honesty",
	},
	{
		icon: "./assets/utilityToken.svg",
		title: "Utility Token",
		description: "Invest in Billboard Utility token",
	},
];


const LandingPage: React.FC = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])

	return (
		<>
			<section className="flex md:blue-elipse justify-center self-stretch pt-64 pb-48 max-md:mt-10 max-md:py-0 ">
				<div className="flex flex-row gap-5 max-md:flex-col max-md:gap-0">
					<div className="w-6/12 max-md:w-full">
						<div className="flex flex-col justify-center px-5 py-4 font-bold max-w-[615px] max-md:mt-10 max-md:max-w-full">
							<h1 className="text-5xl bg-clip-text leading-[72px] max-md:max-w-full text-white max-md:text-4xl max-md:leading-[67px]">
								First Solana Based Advertising Platform
							</h1>
							<p className="mt-12 text-2xl leading-9 text-zinc-400 max-md:mt-10 max-md:max-w-full">
								Spend less as an Advertiser Make more as a Publisher
							</p>
							<Button to={"/app/"} className="self-start mt-12 max-md:mt-10 w-56 text-white" background='linear-gradient(62deg, #6100FF 0%, #00FFD1 100%)'>Open dAPP</Button>
							<div className="flex gap-5 py-1 pr-20 mt-12 text-xs leading-5 text-zinc-400 max-md:flex-wrap max-md:pr-5 max-md:mt-10">
								<div className="flex items-center w-[142px] h-[53px] flex-shrink-0">
									<img
										loading="lazy"
										src={"./assets/01.png"}
										alt="Sponsor"
										className="mr-[-15px]"
									/>
									<img
										loading="lazy"
										src={"./assets/02.png"}
										alt="Sponsor"
										className="mr-[-15px]"
									/>
									<img
										loading="lazy"
										src={"./assets/03.png"}
										alt="Sponsor"
										className="mr-[-15px]"
									/>
								</div>
								<p className="pt-8 pb-px">Community members</p>
							</div>
						</div>
					</div>
					<div className="w-6/12 max-md:w-full">
						<img
							loading="lazy"
							src={"./assets/teaserImage.png"}
							alt="Hero"
							className="rounded-3xl w-full aspect-[1.05] max-md:mt-10 max-md:max-w-full"
						/>
					</div>
				</div>
			</section >
			<section className="flex justify-center self-stretch py-10  bg-neutral-900 max-md:mt-10 ">
				<div className="flex flex-wrap gap-24 justify-center items-center max-w-full max-lg:px-5 max-lg:gap-4">
					<Image src="./assets/solana.png" alt="Partner logo 1" className="self-stretch my-auto max-w-full aspect-[7.14] w-[213px]" />
					<Image src="./assets/phantom.png" alt="Partner logo 2" className="self-stretch aspect-[5] w-[270px]" />
					<Image src="./assets/metamask.png" alt="Partner logo 3" className="self-stretch my-auto aspect-[5.88] w-[270px]" />
				</div>
			</section>
			<section className="flex justify-center self-stretch py-10 mt-40 max-md:mt-10">
				<div className="flex flex-col">
					<h2 className="text-6xl font-bold text-center text-white bg-clip-text leading-[64px] max-md:text-4xl max-md:leading-10"
						style={{}}>
						Why
						<span style={{
							background: 'linear-gradient(45deg, #6100FF, #00FFD1)',
							WebkitBackgroundClip: 'text',
							WebkitTextFillColor: 'transparent',
						}}> choose us?</span>
					</h2>
					<div className="flex flex-row justify-between gap-x-5 mt-24 w-[1024px] max-lg:flex-col max-lg:gap-0 max-lg:mt-5 max-lg:w-full">
						{features.map((feature, index) => (
							<div key={feature.title} className={`flex flex-col w-4/12 max-md:ml-0 max-lg:w-full ${index === 1 ? "mt-16" : "mt-3.5"} max-lg:mt-3.5`} >
								<Feature {...feature} />
							</div>
						))}
					</div>
				</div>
			</section>
			<CallForAction />
		</>
	);


};

export default LandingPage;